import { supabase } from './supabase';

export type AccessProfile = {
  isAdmin: boolean;
  isVenueReviewer: boolean;
  username: string | null;
};

export const SUPER_ADMIN_USERNAME = 'evan';

export function canManageAdmins(p: AccessProfile): boolean {
  return (p.username ?? '').trim().toLowerCase() === SUPER_ADMIN_USERNAME;
}

/** Loads role flags; tolerates missing `is_venue_reviewer` column until migrated. */
export async function fetchAccessProfile(userId: string): Promise<AccessProfile> {
  const full = await supabase
    .from('profiles')
    .select('is_admin, is_venue_reviewer, username')
    .eq('id', userId)
    .maybeSingle();

  if (!full.error && full.data) {
    return {
      isAdmin: Boolean(full.data.is_admin),
      isVenueReviewer: Boolean(full.data.is_venue_reviewer),
      username: full.data.username ?? null,
    };
  }

  const msg = full.error?.message ?? '';
  if (msg.includes('is_venue_reviewer') || msg.includes('column') || full.error?.code === '42703') {
    const fallback = await supabase.from('profiles').select('is_admin, username').eq('id', userId).maybeSingle();
    if (fallback.error) throw new Error(fallback.error.message);
    if (!fallback.data) throw new Error('Profile not found');
    return {
      isAdmin: Boolean(fallback.data.is_admin),
      isVenueReviewer: false,
      username: fallback.data.username ?? null,
    };
  }

  if (full.error) throw new Error(full.error.message);
  throw new Error('Profile not found');
}

export function hasDashboardAccess(p: AccessProfile): boolean {
  return p.isAdmin || p.isVenueReviewer;
}
